import { toDate } from '@/utils/filters'
import { handlePasteInput } from '@/utils/shared'

const select = {
  props: {
    model: { required: true },
    fields: { type: Object, default: () => ({ title: 'title', id: 'id' }) },
    data: { type: [Array, Object], default: () => ([]) },
    placeholder: { type: String },
    clearable: { type: Boolean, default: true },
    filterable: { type: Boolean, default: true },
    filterMethod: { type: Function },
    multiple: { type: Boolean, default: false },
    multipleLimit: { type: Number, default: -1 },
    disabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    size: { type: String, default: '' },
    isShowDisabled: { type: Boolean, default: true },
    getLabel: {
      type: Function,
      default (item) {
        return item[this.fields.title]
      }
    },

    remote: { type: Boolean, default: false },
    remoteMethod: { type: Function, default: function () {} }
  },
  watch: {
    model: {
      immediate: true,
      handler (Val) {
        this.value = Val ||
          ((this.multiple)
            ? []
            : typeof Val === 'number'
              ? Val : null)
      }
    },
    modelItem: {
      immediate: true,
      handler (value) {
        this.$emit('on-data-value', value)
      }
    }
  },
  data () {
    return {
      value: null
    }
  },
  computed: {
    mapData () {
      return this.data.reduce((result, item) => {
        result[item[this.fields.id]] = item
        return result
      }, {})
    },
    modelItem () {
      return this.mapData[this.model] || null
    },
    showedData () {
      if (this.isShowDisabled) return this.data
      return this.data.filter((item) => {
        return !item.disabled
      })
    }
  },
  methods: {
    handlePaste (e) {
      handlePasteInput(e)
    },
    // INTERFACE START
    focus () {
      this.$refs.select.focus()
    },
    // INTERFACE END
    handlerInput (e) {
      this.$emit('on-input', e.target.value)
    },
    handlerFocus () {
      this.$emit('on-focus')
    },
    handlerChange () {
      // Logic disable
      if (this.disabled) return

      const value = this.value || null
      const data = this.mapData[value] || null
      const title = (data && this.getLabel(data)) || null

      this.$emit('update:model', value)
      this.$emit('on-change', value, data, title)
    }
  }
}

const selectMobile = {
  mounted () {
    if (this.$root.isMobile) {
      if (this.multiple) this.$refs.select.setAttribute('multiple', 'true')
      this.findElFormItem()
      if (this.elFormItem) {
        this.materialFiled()
        if (!this.placeholder && !this.multiple) {
          this.$refs.select.addEventListener('focus', this.materialFocus)
          this.$refs.select.addEventListener('blur', this.materialFocus)
        }
      }
    }
  },
  beforeDestroy () {
    if (this.elFormItem && !this.placeholder && !this.multiple) {
      this.$refs.select.removeEventListener('focus', this.materialFocus)
      this.$refs.select.removeEventListener('blur', this.materialFocus)
    }
  },
  methods: {
    focus () {
      this.$refs.select.focus()
    },
    valueToBool (Value) {
      if (this.$_.isArray(Value)) {
        return (Value.length)
      } else {
        return (Value)
      }
    },
    findElFormItem () {
      const findFunc = (Component) => {
        if (!this.elFormItem) {
          if (Component.$options.name === 'ElFormItem') {
            this.elFormItem = Component
          } else if (Component.$options.name === 'root') {
            return false
          } else if (Component.$parent) {
            findFunc(Component.$parent)
          }
        }
      }
      findFunc(this.$parent)
    },
    materialFiled () {
      if (this.$root.isMobile) {
        if (this.placeholder || this.multiple) {
          this.$parent.$el.setAttribute('data-filed', 'true')
        } else {
          this.elFormItem.$el[this.valueToBool(this.value) ? 'setAttribute' : 'removeAttribute']('data-filed', true)
        }
      }
    },
    materialFocus (e) {
      this.elFormItem.$el[e.type === 'focus' ? 'setAttribute' : 'removeAttribute']('data-focus', true)
    }
  }
}
const selectColumns = {
  props: {
    columns: { type: Array, default: () => ([]) } // [{title: 'title', value: 'id', template: ${data.id}, type: 'string', originField: 'part.partNumber' }]
  },
  computed: {
    tooltipItems () {
      if (this.model && this.modelItem) {
        return this.columns
          .map(({ title, value, template }) => {
            return {
              title,
              value: template ? this.checkEs6AndRun(template, this.modelItem) : this.modelItem[value]
            }
          })
          .filter(({ value }) => !!value)
      } else {
        return []
      }
    },
    isDisableTooltip () {
      return !this.tooltipItems.length
    }
  },
  methods: {
    parseColumnValue (item, column) {
      if (column.type === 'date') {
        return toDate(item[column.value])
      }
      if (column.template) {
        return this.checkEs6AndRun(column.template, item)
      } else {
        return item[column.value]
      }
    }
  }
}
export {
  select,
  selectMobile,
  selectColumns
}
